import { render, staticRenderFns } from "./ShowCreate.vue?vue&type=template&id=6bf6c110"
import script from "./ShowCreate.vue?vue&type=script&lang=js"
export * from "./ShowCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports